import { createContext, type FunctionComponent, use } from 'react';

import type { AdminApiProviderContext, AdminApiProviderProps, AdminServerClient } from './AdminApiProvider.types';

const AdminApiContext = createContext<AdminApiProviderContext | null>(null);
AdminApiContext.displayName = 'AdminApiContext';

const AdminApiProvider: FunctionComponent<AdminApiProviderProps> = ({ children, ...props }) => {
  return <AdminApiContext value={{ ...props }}>{children}</AdminApiContext>;
};

const useAdminApi = (): { server: AdminServerClient } => {
  const api = use(AdminApiContext);

  if (!api) {
    throw new Error('useAdminApi Hook must be used within an AdminApiProvider');
  }

  return { server: api.server };
};

export { AdminApiProvider, useAdminApi };
